import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import RiskRegisterUI from './RiskRegisterUI.js'

class RiskRegisterSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      riskRegisterList: null,
      riskUpdated: false
    }
  }

  render() {
    return (
      <RiskRegisterUI
        context={this.props.context}
        errorList={this.state.errorList}
        riskRegisterList={this.state.riskRegisterList}
        year={this.state.year}
        month={this.state.month}
        yearMonth={this.state.yearMonth}
        onPreviousClick={this.onPreviousClick}
        onNextClick={this.onNextClick}
        onRefreshClick={this.onRefreshClick}
        //
        riskUpdated={this.state.riskUpdated}
        selectedRisk={this.state.selectedRisk}
        onRiskRegistersUpdateClick={this.onRiskRegistersUpdateClick}
        onRiskRegistersUpdateCancel={() => { this.setState({ riskUpdated: false }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getRiskRegisters(context, '', '')
  }

  onPreviousClick = () => {
    let context = this.props.context
    this.getRiskRegisters(context, this.state.previousYear, this.state.previousMonth)
  }

  onNextClick = () => {
    let context = this.props.context
    this.getRiskRegisters(context, this.state.nextYear, this.state.nextMonth)
  }

  getRiskRegisters(context, year, month) {
    year = year === 'undefined' ? '' : year
    month = month === 'undefined' ? '' : month

    let cacheManager = new CacheManager({
      resource: `/api/su/riskRegisters`,
      cacheKey: CacheKeys.RiskRegisters(year, month),
      callback: this.getRiskRegistersCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context, {}, { year: year, month: month })
  }

  getRiskRegistersCallback = (response) => {
    this.setState({
      riskRegisterList: response.riskRegisterList,
      year: response.year, month: response.month, yearMonth: response.yearMonth,
      nextYear: response.nextYear, nextMonth: response.nextMonth,
      previousYear: response.previousYear, previousMonth: response.previousMonth
    })
  }

  onRiskRegistersUpdateClick = (event) => {
    let riskCode = event.currentTarget.getAttribute('data-code')
    let selectedRisk = this.state.riskRegisterList.filter(p => p.riskCode === riskCode)[0]
    this.setState({
      riskUpdated: true,
      selectedRisk: selectedRisk
    })
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.RiskRegisters(this.state.year, this.state.month))
    if (noBusy === 'noBusy') {
      this.getRiskRegisters(context, this.state.year, this.state.month)
    }
    else
      this.setState({ riskRegisterList: null, errorList: null },
        this.getRiskRegisters(context, this.state.year, this.state.month)
      )
  }
}

export default RiskRegisterSF

